// Modal interno de detalhes de tx — substitui o link pro blockscout (não
// existe mais). Fecha com Esc ou clique fora. "ver no nó" aponta pro
// endpoint /tx/<hash> do próprio nó (JSON cru).
import { formatSIMC, shortAddress } from './format.js';

let el = null;
let apiUrl = '';

function ensure() {
  if (el) return el;
  el = document.createElement('div');
  el.className = 'tx-modal-backdrop';
  el.innerHTML = `
    <div class="tx-modal" role="dialog" aria-modal="true">
      <button type="button" class="tx-modal__close" aria-label="Fechar">×</button>
      <div class="tx-modal__body"></div>
    </div>
  `;
  document.body.appendChild(el);
  el.addEventListener('click', (event) => {
    if (event.target === el) close();
  });
  el.querySelector('.tx-modal__close').addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
  return el;
}

export function initTxModal(url) {
  apiUrl = url;
}

function row(label, value) {
  return `<div class="tx-modal__row"><dt>${label}</dt><dd>${value}</dd></div>`;
}

export function openTxModal(payment, store) {
  if (!payment) return;
  const node = ensure();
  const from = store.nodes.get(payment.from)?.agent;
  const to = store.nodes.get(payment.to)?.agent;
  const fromLabel = from ? `${from.emoji} ${from.name}` : shortAddress(payment.from);
  const toLabel = to ? `${to.emoji} ${to.name}` : shortAddress(payment.to);
  const when = payment.timestamp ? new Date(payment.timestamp).toLocaleString('pt-BR') : '—';

  node.querySelector('.tx-modal__body').innerHTML = `
    <h3 class="tx-modal__title">Pagamento</h3>
    <dl class="tx-modal__grid">
      ${row('Hash', `<span class="tabular-nums">${payment.hash}</span>`)}
      ${row('De', `${fromLabel} <span class="tx-modal__addr">${payment.from}</span>`)}
      ${row('Para', `${toLabel} <span class="tx-modal__addr">${payment.to}</span>`)}
      ${row('Valor', `${formatSIMC(payment.value)} SIMC`)}
      ${row('Ref', `<span class="tabular-nums">${payment.ref ?? '—'}</span>`)}
      ${row('Seq / idx', `<span class="tabular-nums">${payment.seq ?? '—'} / ${payment.idx}</span>`)}
      ${row('Quando', when)}
    </dl>
    <a class="tx-modal__link" href="${apiUrl}/tx/${payment.hash}" target="_blank" rel="noopener">ver no nó →</a>
  `;
  node.classList.add('visible');
}

function close() {
  el?.classList.remove('visible');
}
